export default __webpack_public_path__ + "static/media/Alpha_10_x_15.14cf3839.jpg";